<template>
  <div>
    <div v-if="groupByKey !== false">
      <div v-for="(group, groupName) in eventsGroups" :key="String(groupName)">
        <h2 class="mt-3 date_group">{{ groupName }}</h2>
        <BRow class="vip-event-columns">
          <BCol v-for="e in group" :key="e.id" md="4" sm="6">
            <EventCard
              :event="e"
              :event-list-path="eventListPath"
              @reg_action="$emit('reg_action', $event)"
            />
          </BCol>
        </BRow>
      </div>
    </div>
    <div v-else>
      <BRow class="vip-event-columns">
        <BCol v-for="e in events" :key="e.id" md="4" sm="6">
          <EventCard
            :event="e"
            :event-list-path="eventListPath"
            @reg_action="$emit('reg_action', $event)"
          />
        </BCol>
      </BRow>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import EventCard from './EventCard.vue'

function groupBy<T extends Record<string, unknown>>(array: T[], key: string) {
  const result: Record<string, T[]> = {}
  array.forEach((item) => {
    const k = String(item[key] ?? '')
    if (!result[k]) {
      result[k] = []
    }
    result[k].push(item)
  })
  return result
}

const props = withDefaults(
  defineProps<{
    events?: ({ id: number } & Record<string, unknown>)[]
    /** Field name to group by, or `false` for a flat list */
    group_by?: string | false
    /** Localized list URL from the page, e.g. `localePath('/vip/program/')` */
    eventListPath: string
  }>(),
  {
    events: () => [],
    group_by: 'human_date',
  },
)

defineEmits<{
  reg_action: [payload: unknown]
}>()

const groupByKey = computed(() => props.group_by)

const eventsGroups = computed(() => {
  if (props.group_by === false) {
    return {}
  }
  return groupBy(props.events, props.group_by)
})
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.date_group {
  font-weight: 800;
}
.vip-event-columns {
  @include media-breakpoint-up(sm) {
    column-count: 4;
  }
}
</style>
